import {
  contactConfig,
  getContactWhatsAppLink,
} from "../../../../../../shared/config/contact.config";

export const contactCopyByMode = {
  all: {
    titleMain: "Agende seu atendimento",
    titleAccent: "especial",
    description:
      "Entre em contato para tirar dúvidas, conhecer melhor os serviços e agendar seu atendimento com mais praticidade.",
    button: "Agendar atendimento",
  },
  aesthetics: {
    titleMain: "Agende sua avaliação",
    titleAccent: "estética",
    description:
      "Entre em contato para tirar dúvidas, conhecer melhor os procedimentos e agendar sua avaliação com mais praticidade.",
    button: "Agendar avaliação estética",
  },
  nutrition: {
    titleMain: "Agende sua consulta",
    titleAccent: "nutricional",
    description:
      "Entre em contato para tirar dúvidas, conhecer melhor o acompanhamento nutricional e agendar sua consulta com mais praticidade.",
    button: "Agendar consulta nutricional",
  },
};

export function getContactItems(mode = "all") {
  return [
    {
      label: "WhatsApp",
      value: contactConfig.whatsapp.display,
      href: getContactWhatsAppLink(mode),
      action: "Conversar",
      iconKey: "whatsapp",
    },
    {
      label: "Instagram",
      value: contactConfig.instagram.handle,
      href: contactConfig.instagram.href,
      action: "Acessar",
      iconKey: "instagram",
    },
    {
      label: "E-mail",
      value: contactConfig.email.value,
      href: contactConfig.email.href,
      action: "Enviar e-mail",
      iconKey: "email",
    },
    {
      label: "Endereço",
      value: contactConfig.address.full,
      href: contactConfig.address.mapsSearch,
      action: "Ver rota",
      iconKey: "address",
    },
  ];
}

export const trustItems = [
  {
    iconKey: "leaf",
    title: "Atendimento",
    text: "100% personalizado",
  },
  {
    iconKey: "calendar",
    title: "Agendamento",
    text: "fácil e rápido",
  },
  {
    iconKey: "lock",
    title: "Suas informações",
    text: "estão seguras",
  },
  {
    iconKey: "heart",
    title: "Cuidado que transforma",
    text: "sua vida",
  },
];

export const mapEmbedUrl = contactConfig.address.mapsEmbed;
export const mapSearchUrl = contactConfig.address.mapsSearch;